import * as React from 'react';

import { CashAccounts } from '../../../../roadmap/components/go/CashAccounts';

export default function CashAccountsScreen() {
    return <CashAccounts />;
}
